@if (status) {
  <div
    appFolderStatus
    class="folder-status {{ type }} {{ status.color }}"
    [type]="type"
    [active]="isActive"
    [noMove]="noMove"
    [status]="status"
    (click)="onClickOnStatus()"
    [class.disabled]="isDisabled">
    <app-folder-status-circle
      class="folder-status__circle"
      [type]="type"
      [color]="status.color"
      [active]="isActive"
      [clickable]="type === 'full-actions'"
      (editStatusColor)="clickEditStatusColor()"></app-folder-status-circle>
    <div class="folder-status__name" [ngClass]="{ 'no-move': status.lastDefault }">
      <h4 class="folder-status__text">
        {{ status.nameForTranslate | translate }}
      </h4>
    </div>
    @if (type === 'filter' && status.candidateNumber >= 0) {
      <div class="folder-status__number">
        <h5 class="folder-status__text">
          {{ status.candidateNumber | numberWithSpaces }}
        </h5>
      </div>
    }
    @if (type === 'full-actions' && !status.systemStatus) {
      <div class="folder-status__actions">
        <svg
          width="12"
          height="12"
          class="edit-folder-status-btn icon"
          (click)="clickEditStatusName()">
          <use xlink:href="#edit-pencil"></use>
        </svg>
        @if (
          profileUserRoleLabel === 'admin' || (status.userId && status.userId === currentUserId)
        ) {
          <svg
            width="10"
            height="10"
            class="remove-folder-status-btn icon"
            (click)="clickRemoveStatus()">
            <use xlink:href="#large-cross"></use>
          </svg>
        }
      </div>
    }
  </div>
}
